export const PALETTE = {
  bg: 0x0b0d10,
  panel: 0x141821,
  panelEdge: 0x2a3140,
  text: 0xd8dee9,
  textDim: 0x6f7787,
  good: 0x9ece6a,
  bad: 0xf7768e,
  warn: 0xe0af68,

  grass: 0x4a7a3a,
  grassEdge: 0x35592a,
  forest: 0x2a4a23,
  forestEdge: 0x1c3017,
  water: 0x2c5d8e,
  waterEdge: 0x1d3f60,
  mountain: 0x6e6e74,
  mountainEdge: 0x4a4a50,

  resourceTree: 0x254a18,
  resourceFood: 0xc9b257,

  player: [0x4a90e2, 0xd2483a, 0x3a9a4f, 0xd4a017, 0x9b59b6, 0xe67e22] as const,
  playerEdge: [0x254e80, 0x80281f, 0x1e5a2a, 0x7a5c0e, 0x5b3570, 0x8a4c14] as const,

  selection: 0xffffff,
  ghostOk: 0x9ece6a,
  ghostBad: 0xf7768e,
  hpFull: 0x9ece6a,
  hpLow: 0xf7768e,
  hpBack: 0x161a22,
} as const;

/** Tiled dark-texture background for UI panels & windows. */
export const PANEL_BG = "#141821 url('ui-loop-background.png') repeat";

export type PlayerId = 0 | 1 | 2 | 3 | 4 | 5;

export const PLAYER_COUNT = 6;
